import React from 'react';
import PublicNav from './PublicNav';
import PublicFooter from './PublicFooter';

/**
 * PublicLayout — wrapper for all public pages.
 *
 * Props:
 *  - variant: 'default' | 'acq'
 *      'default' → uses global light/dark theme tokens (/join, /tools)
 *      'acq'     → forces the ultra-dark acquisition palette (/login, /register)
 *  - navProps, footerProps forwarded to PublicNav / PublicFooter
 *  - contentClassName: extra classes on the <main> (e.g. remove pt for
 *    pages that want to rely on full-viewport inner layouts like a split hero)
 */
export default function PublicLayout({
  children,
  variant = 'default',
  navProps,
  footerProps,
  contentClassName = '',
}) {
  const isAcq = variant === 'acq';
  const rootClass = [
    isAcq ? 'acq' : '',
    'min-h-screen bg-background text-foreground flex flex-col',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={rootClass}>
      <PublicNav {...navProps} showThemeToggle={!isAcq && navProps?.showThemeToggle !== false} />
      <main className={`flex-1 pt-16 ${contentClassName}`}>{children}</main>
      <PublicFooter {...footerProps} />
    </div>
  );
}
